import type { UUID } from "utils";

const BASE_URL = "/configuration/customers";

export const PAGE_URLS = {
  addressEdit: `${BASE_URL}/:id/address`,
  list: BASE_URL,
  create: `${BASE_URL}/create`,
  dynamicBeneficiaries: `${BASE_URL}/:id/dynamic-beneficiaries`,
  dynamicBeneficiariesCreate: `${BASE_URL}/:id/dynamic-beneficiaries/create`,
  paymentConfiguration: `${BASE_URL}/:id/payment-configuration`,
  details: `${BASE_URL}/:id`,
  edit: `${BASE_URL}/:id/edit`,
  getEdit: (id: UUID) => `${BASE_URL}/${id}/edit`,
  getCashManagement: (id: UUID) => `${BASE_URL}/${id}/cash-management`,
  getCheckoutBranding: (id: UUID) => `${BASE_URL}/${id}/checkout-branding`,
  getAddressEdit: (id: UUID) => `${BASE_URL}/${id}/address`,
  getCreateDynamicBeneficiaries: (id: UUID) =>
    `${BASE_URL}/${id}/dynamic-beneficiaries/create`,
  getDetails: (id: UUID) => `${BASE_URL}/${id}`,
  getDynamicBeneficiaries: (id: UUID) =>
    `${BASE_URL}/${id}/dynamic-beneficiaries`,
  getPaymentConfiguration: (id: UUID) =>
    `${BASE_URL}/${id}/payment-configuration`,
} as const;
